var map = {
	".": "./src/prototypes/index.js",
	"./": "./src/prototypes/index.js",
	"./array.prototype": "./src/prototypes/array.prototype.js",
	"./array.prototype.js": "./src/prototypes/array.prototype.js",
	"./index": "./src/prototypes/index.js",
	"./index.js": "./src/prototypes/index.js",
	"./number.prototype": "./src/prototypes/number.prototype.js",
	"./number.prototype.js": "./src/prototypes/number.prototype.js",
	"./string.prototype": "./src/prototypes/string.prototype.js",
	"./string.prototype.js": "./src/prototypes/string.prototype.js",
	"./vue.prototype": "./src/prototypes/vue.prototype.js",
	"./vue.prototype.js": "./src/prototypes/vue.prototype.js",
	"./window.prototype": "./src/prototypes/window.prototype.js",
	"./window.prototype.js": "./src/prototypes/window.prototype.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/prototypes sync recursive ^.*$";